export const iconFontAwesomeTravelHotelTruckFront = (
	<i className="fa-solid fa-truck-front"></i>
);
